import React from "react";
import { formatIDR } from "../../../utils/helpers/formatIDR";
import ModalShell from "../../CashBankPage/components/ModalShell";
import { PERIOD_LABELS, STATUS_META, formatDateTime } from "../constants";

const DetailModal = ({ expense, onClose }) => {
  const status = STATUS_META[expense?.status] || { label: expense?.status || "-", className: "bg-secondary-lt" };

  return (
    <ModalShell
      eyebrow="DETAIL BIAYA"
      title={expense?.expense_no || "Biaya operasional"}
      subtitle="Informasi transaksi dan jejak audit saldo Kas & Bank."
      onClose={onClose}
      size="xl">
      <div className="operational-expense-detail-hero">
        <div>
          <span>Kategori</span>
          <strong>{expense?.category_name || "-"}</strong>
          <small>{expense?.category_description || "Biaya operasional outlet"}</small>
        </div>
        <div className="text-end">
          <span>Jumlah biaya</span>
          <strong>{formatIDR(expense?.amount)}</strong>
          <span className={`badge ${status.className}`}>{status.label}</span>
        </div>
      </div>

      <div className="operational-expense-detail-grid">
        <div><span>Akun pembayaran</span><strong>{expense?.account_name || "-"}</strong><small>Saldo sekarang {formatIDR(expense?.account_current_balance)}</small></div>
        <div><span>Periode biaya</span><strong>{PERIOD_LABELS[expense?.period_type] || "-"}</strong><small>Sifat biaya yang dicatat</small></div>
        <div><span>Waktu transaksi</span><strong>{formatDateTime(expense?.occurred_at)}</strong><small>Dibuat oleh {expense?.created_by_name || "Sistem"}</small></div>
        <div><span>Terakhir diperbarui</span><strong>{formatDateTime(expense?.updated_at)}</strong><small>{expense?.updated_by_name || expense?.created_by_name || "Sistem"}</small></div>
      </div>

      {expense?.schedule_id ? (
        <section className={`operational-expense-recurring-card ${expense?.schedule_is_active ? "is-active" : ""}`}>
          <div className="operational-expense-recurring-copy">
            <span className="operational-expense-recurring-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M20 7h-9a4 4 0 0 0-4 4v1M4 17h9a4 4 0 0 0 4-4v-1" />
                <path d="m17 4 3 3-3 3M7 14l-3 3 3 3" />
              </svg>
            </span>
            <div>
              <strong>{expense?.schedule_is_active ? "Jadwal otomatis aktif" : "Jadwal otomatis dinonaktifkan"}</strong>
              <small>
                {expense?.schedule_is_active
                  ? `Pencatatan berikutnya ${formatDateTime(expense?.schedule_next_run_at)}${expense?.schedule_ends_at ? ` · berakhir ${formatDateTime(expense.schedule_ends_at)}` : ""}.`
                  : "Transaksi berikutnya tidak akan dibuat sampai jadwal diaktifkan kembali."}
              </small>
              {expense?.schedule_last_error ? <span className="operational-expense-schedule-error">Jadwal tertunda: {expense.schedule_last_error}</span> : null}
            </div>
          </div>
          <span className={`badge ${expense?.schedule_is_active ? "bg-success-lt" : "bg-secondary-lt"}`}>
            {expense?.schedule_is_active ? "Aktif" : "Nonaktif"}
          </span>
        </section>
      ) : null}

      <section className="operational-expense-detail-section">
        <div className="operational-expense-section-heading">
          <div><h4>Keterangan</h4><p>Catatan yang membantu proses audit.</p></div>
        </div>
        <div className="operational-expense-note">{expense?.note || "Tidak ada keterangan tambahan."}</div>
      </section>

      {expense?.status === "cancelled" ? (
        <div className="operational-expense-cancellation">
          <div><strong>Transaksi dibatalkan</strong><span>{formatDateTime(expense?.cancelled_at)} · {expense?.cancelled_by_name || "Sistem"}</span></div>
          <p>{expense?.cancellation_reason || "Tidak ada alasan pembatalan."}</p>
        </div>
      ) : null}

      <section className="operational-expense-detail-section">
        <div className="operational-expense-section-heading">
          <div><h4>Jejak audit</h4><p>Histori tidak dihapus; pembatalan dicatat sebagai reversal.</p></div>
        </div>
        <div className="table-responsive operational-expense-audit-table">
          <table className="table table-vcenter card-table mb-0">
            <thead><tr><th>Waktu</th><th>Aktivitas</th><th>Nominal</th><th>Saldo Sebelum</th><th>Saldo Sesudah</th><th>Pengguna</th></tr></thead>
            <tbody>
              {(expense?.events || []).map((event) => {
                const posted = event.event_type === "posted";
                return (
                  <tr key={event.id}>
                    <td>{formatDateTime(event.occurred_at)}</td>
                    <td><span className={`badge ${posted ? "bg-success-lt" : "bg-danger-lt"}`}>{posted ? "Biaya dicatat" : "Reversal"}</span>{event.reason ? <small className="d-block text-secondary mt-1">{event.reason}</small> : null}</td>
                    <td className={posted ? "text-danger fw-bold" : "text-primary fw-bold"}>{posted ? "−" : "+"}{formatIDR(Math.abs(Number(event.signed_amount || 0)))}</td>
                    <td>{formatIDR(event.balance_before)}</td>
                    <td className="fw-bold">{formatIDR(event.balance_after)}</td>
                    <td>{event.created_by_name || "Sistem"}</td>
                  </tr>
                );
              })}
              {!expense?.events?.length ? <tr><td colSpan="6" className="text-center text-secondary py-4">Jejak audit belum tersedia.</td></tr> : null}
            </tbody>
          </table>
        </div>
      </section>
    </ModalShell>
  );
};

export default DetailModal;
